import React, { useContext, useState } from 'react'
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import CLabel from '../../../../Common/CLabel'
import moment from 'moment';
import { useBoolean } from '@fluentui/react-hooks';
import './style-card.css'
import { ActionButton, ScrollablePane, ScrollbarVisibility } from '@fluentui/react';
import GapRevisionInfoTool from '../GapRevisionInfoBox';
import SidePanelViewAllAction from '../Fishbone/SidePanelViewAllAction';
import MainAppContext from '../../../../../MainAppContext';
import GapAppContext from '../../../../../GapAppContext';
import SidePanelAddRevision from '../../DialogGenerateGap/SidePanelAddRevision';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../common/ObjectStructures/Trasnversal';
import { _checkSecurityUser } from '../../../../../common/Helpers/HLP_Security';
import { __enum_PageMode, enum__PRIVILEGES } from '../../../../../common/Dictionaries';

function GapRevisionsBox(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextGap = useContext(GapAppContext);

    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    const [isAddRevisionPanelOpen, setIsAddRevisionPanelOpen] = useState(false);
    const [isProcessRevisionPanelOpen, setIsProcessRevisionPanelOpen] = useState(false);
    const {
        inputParam_GapAnalyzeId = null,
        inputParam_SetterSelectedRevision = null,
        inputParam_GapElementId = null,
        inputParam_SetterDataToNull = null,
        gapRevisionsList = null,
        setGapRevisionsList = null,
    } = props;
    const [gapAnalyzeIdToAddRevisionId, setGapAnalyzeIdToAddRevisionId] = useState(null);
    const [gapAnalyzeNameToAddRevisionId, setGapAnalyzeNameToAddRevisionId] = useState(null);
    const [selectedRevisionId, setSelectedRevisionId] = useState(gapRevisionsList.data[0].id);
    const [selectedRevisionStatusId, setSelectedRevisionStatusId] = useState(null);
    
    const _priv_canProcessGapRevision = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_GapElementId, enum__PRIVILEGES.GAP_CONTRACT_ANALYZE)
    const _priv_canAddGapRevision = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_GapElementId, enum__PRIVILEGES.GAP_CONTRACT_ANALYZE)

    const onSelectRevisionClick = (revision) => {
        setSelectedRevisionId(revision.id)
        inputParam_SetterSelectedRevision && inputParam_SetterSelectedRevision(revision, gapRevisionsList)
        //inputParam_SetterDataToNull && inputParam_SetterDataToNull()
    }

    const onProcessRevision = (revisionStatusId) => {
        setSelectedRevisionStatusId(revisionStatusId)
        setIsProcessRevisionPanelOpen(true)
    }

    const onOpenRevisionPanel = (gapAnalyzeId, gapAnalyzeName) => {
        setIsAddRevisionPanelOpen(true);
        setGapAnalyzeIdToAddRevisionId(gapAnalyzeId);
        setGapAnalyzeNameToAddRevisionId(gapAnalyzeName)
    }

    const onRenderAditionalRevisionInformationElement = (langKeywordText, revisionStatusId, revisionId) => {
        return <div className='d-flex'>
                    <div>
                        {
                            _priv_canProcessGapRevision.value && _priv_canProcessGapRevision.mode === __enum_PageMode.Edit ?
                            <ActionButton onClick={ () => onProcessRevision(revisionStatusId) } iconProps={{ iconName: 'Share' }} allowDisabledFocus>
                                { t(langKeywordText) }
                            </ActionButton> :
                            <ActionButton onClick={ null } disabled={true} iconProps={{ iconName: 'Share' }} allowDisabledFocus>
                                { t(langKeywordText) }
                            </ActionButton>
                        }
                    </div>
                    <div>
                        <GapRevisionInfoTool
                            inputParam_GapAnalyzeId={ inputParam_GapAnalyzeId }
                            inputParam_GapRevisionId={ revisionId }
                            inputParam_GapSelectedRevisionId={ selectedRevisionId }
                            inputParam_GapElementId={inputParam_GapElementId}
                            inputParam_ToggleHideDialog={toggleHideDialog}
                            inputParam_HideDialog={hideDialog}
                        />
                    </div>
                </div>
    }

    return (
        <>
            <Card className='h-100'>
                <Card.Header className="card-header-compact">
                    <Card.Title className="d-flex justify-content-between">
                        <b>{t('data-lang-boxname-gaprevisions')}</b>
                    </Card.Title>
                </Card.Header>
                <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                    <div className='book-toolbar d-flex float-end'>
                        {
                            _priv_canAddGapRevision.value && _priv_canAddGapRevision.mode === __enum_PageMode.Edit &&
                            <ActionButton onClick={ () => onOpenRevisionPanel(inputParam_GapAnalyzeId, inputParam_GapAnalyzeId) } iconProps={{ iconName: 'Share' }} allowDisabledFocus>
                                { t('data-lang-btn-addrevision2') }
                            </ActionButton>
                        }
                    </div>
                </Card.Footer>
                <Card.Body className="h-100">
                    <div>
                        <Row className='pb-2 d-none d-sm-flex border-bottom'>
                            <Col>
                                <Row>
                                    <Col xs={4} xl={4}>
                                    <b>{t('data-lang-lbl-title')}</b>
                                    </Col>
                                    <Col xs={4} xl={4}>
                                    <b>{t('data-lang-lbl-status')}</b>
                                    </Col>
                                    <Col xs={4} xl={4}>
                                    <b>{t('data-lang-lbl-period')}</b>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={2} xl={2}>
                            <b>{t('data-lang-lbl-actions')}</b>
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col>
                                <ScrollablePane
                                    style={{ minHeight: "242px", maxHeight: "100%", height: "100%"}}
                                    styles={{
                                        root: { position: "relative" },
                                        contentContainer:{overflowX: "hidden"}
                                    }}
                                    scrollbarVisibility={ScrollbarVisibility.auto}
                                    scrollContainerFocus={true}
                                >
                                    {
                                        gapRevisionsList.data !== null && gapRevisionsList.data.map((revision, index) => (
                                            <div key={index} className="pb-1">
                                                <Row className={` d-sm-flex d-none cursor-pointer ps-2${selectedRevisionId === revision.id ? " revision-selected" : ""}`} onClick={() => onSelectRevisionClick(revision)}>
                                                    <Col>
                                                        <Row>
                                                            <Col xs={4} xl={4} className='border-end border-info'>
                                                                <CLabel className='pt-2 pb-0 mb-0' labelValue={`${t('data-lang-lbl-revision')} - ${moment(revision.referenceDate).format('YYYY/MM/DD')}`} /> <div className='pt-0 mt-0' style={{fontSize: "10px"}}>(REV{revision.id} - {revision.author})</div>
                                                            </Col>
                                                            <Col xs={4} xl={4} className='border-end border-info'>
                                                                <CLabel className='pt-2' labelValue={t(`data-lang-skrevision-status${revision.statusId}`)} />
                                                            </Col>
                                                            <Col xs={4} xl={4} className='border-end border-info d-flex'>
                                                                <CLabel className='pt-2' labelValue={revision.periodId} />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col className='col-auto'>
                                                        {
                                                            onRenderAditionalRevisionInformationElement('data-lang-btn-process', revision.statusId, revision.id)
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row className={`d-flex d-sm-none cursor-pointer ps-2${selectedRevisionId === revision.id ? " revision-selected" : ""}`} onClick={() => onSelectRevisionClick(revision.id)}>
                                                    <Row>
                                                        <Col>
                                                            <CLabel className='pt-2' labelText={t('data-lang-lbl-revision')} labelValue={`REV${revision.id} - ${moment(revision.referenceDate).format('DD/MM/YYYY')}`} />
                                                        </Col>
                                                        <Col>
                                                            {
                                                                onRenderAditionalRevisionInformationElement('data-lang-btn-process',  revision.statusId, revision.id)
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <CLabel className='pt-2' labelText={t('data-lang-lbl-period')} labelValue={revision.periodId} />
                                                        </Col>
                                                        <Col>
                                                            <CLabel className='pt-2' labelText={t('data-lang-lbl-status')} labelValue={revision.statusId} />
                                                        </Col>
                                                    </Row>
                                                </Row>
                                            </div>
                                        ))
                                    }
                                </ScrollablePane>
                            </Col>
                        </Row>
                    </div>
                </Card.Body>
            </Card>
            {
                inputParam_GapAnalyzeId !== null && gapAnalyzeIdToAddRevisionId !== null &&
                <SidePanelAddRevision 
                    inputParam_GapAnalyzeId={gapAnalyzeIdToAddRevisionId}
                    inputParam_GapAnalyzeName={gapAnalyzeNameToAddRevisionId}
                    
                    inputParam_IsPanelOpen={isAddRevisionPanelOpen}
                    inputParam_SetterIsPanelOpen={setIsAddRevisionPanelOpen}
                    inputParam_EditMode={false}
                    inputParam_SetRevisionList={setGapRevisionsList}
                    inputParam_RevisionList={gapRevisionsList.data}
                />
            }
            <SidePanelViewAllAction
                inputParam_EditMode={true}
                inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                inputParam_GapRevisionId={selectedRevisionId}
                inputParam_IsPanelOpen={isProcessRevisionPanelOpen}
                inputParam_SetterIsPanelOpen={setIsProcessRevisionPanelOpen}
                inputParam_SelectedRevisionStatusId={selectedRevisionStatusId}
                
                inputParam_GapRevisionsList={gapRevisionsList.data}
                inputParam_SetGapRevisionsList={setGapRevisionsList}
                
            />
        </>
    );
}

GapRevisionsBox.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number,
    inputParam_GapElementId: PropTypes.number,
    inputParam_SetterSelectedRevision: PropTypes.func,
    inputParam_SetterDataToNull: PropTypes.func,
};

export default GapRevisionsBox;

